import React from "react";
import { Chat, useCreateChatClient } from "stream-chat-react";
import { useUser } from "../hooks/user";
import config from "../config";

const USER_ID = "admin-boom";

const ChatProviderWrapper = ({ children }) => {
  const { user } = useUser();
  const streamChatToken = user?.streamChatToken;

  const client = useCreateChatClient({
    apiKey: config.streamApiKey,
    tokenOrProvider: streamChatToken,
    userData: { id: USER_ID },
  });

  if (!client) return children;

  return (
    <Chat client={client} theme="messaging light">
      {children}
    </Chat>
  );
};

export const ChatProvider = ({ children }) => {
  const { user } = useUser();
  const streamChatToken = user?.streamChatToken;
  if (!streamChatToken || !config.streamApiKey) return children;

  return <ChatProviderWrapper>{children}</ChatProviderWrapper>;
};
